import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {
  truBlueStatus,
  chemicalBaseTypeNames,
} from 'helpers/constants';
import phoneFormat from 'util/phoneformat';
import {trublueMemberIDEnabled} from 'features';

class CustomerContactTrashBinRecord extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
    record: PropTypes.object.isRequired,
    dealer: PropTypes.object.isRequired,
  };

  render() {
    const {record, dealer} = this.props;
    const contact = record.contact;
    let contactName;

    if (contact.nameFirst || contact.nameLast) {
      contactName = (contact.nameFirst || '') + ' ' + (contact.nameLast || '');
      contactName += contact.organization ? ' | ' + contact.organization : '';
    } else {
      contactName = contact.organization;
    }

    return (
      <div className="trashbin-record-content">
        <h4 className='trashbin-record-content__heading'><FormattedMessage id="general.account.details"/></h4>
        <div>
          <label>
            <strong>
              <FormattedMessage id="general.alexid"/>:
            </strong>
            <span className="value">{record.customer.accountNum}</span>
          </label>
        </div>
        <div>
          {record.customer.POSVendorID ?
            <label>
              <strong>
                <FormattedMessage id="general.posid" />:
              </strong>
              <span className="value">{record.customer.POSVendorID}</span>
            </label> :
         null}
        </div>
        <div>
          {trublueMemberIDEnabled && record.customer.truBlueMemberID &&
        record.customer.truBlueStatus === truBlueStatus.Active ?
          <label>
            <strong>
              <FormattedMessage id="general.trublue.memberID" />:
            </strong>
            <span className="value">{record.customer.truBlueMemberID}</span>
          </label> :
         null}
        </div>
        <div>
          <label>
            <strong>
              <FormattedMessage id="general.address"/>:
            </strong>
            <span className="value">
              {`${record.customer.address1} ${record.customer.address2 || ''} | ${
            record.customer.city || dealer.city || '--'
          } | ${record.customer.state || dealer.state} | ${
            record.customer.zip || dealer.zip || '--'
          }`} </span>
          </label>
        </div>
        <h4 className='trashbin-record-content__heading'><FormattedMessage id="customer.contact.information"/></h4>
        <div className='contact-summary' key={contact.ID}>
          <div className='contact-summary__content'>
            <p className='contact-summary__name'>{contactName}</p>
            <p className='contact-summary__details'>
              {contact.email ?
                <div>
                  <label>
                    <FormattedMessage id="general.email" />:
                  </label>
                  <span className="value">{contact.email}</span>
                </div> :
                 null}
              {contact.homePhone ?
                <div>
                  <label>
                    <FormattedMessage id="general.phone.number" />
                    <span className="dim n">
                          &nbsp;(
                      <FormattedMessage id="general.primary" />):
                    </span>
                  </label>
                  <span className="value">{phoneFormat(contact.homePhone)}</span>
                </div> :
                 null}
              {contact.workPhone ?
                <div>
                  <label>
                    <FormattedMessage id="general.phone.number" />
                    <span className="dim n">
                          &nbsp;(
                      <FormattedMessage id="general.alternate" />):
                    </span>
                  </label>
                  <span className="value">{phoneFormat(contact.workPhone)}</span>
                </div> :
                 null}
              {contact.mobilePhone ?
                <div>
                  <label>
                    <FormattedMessage id="general.phone.number" />
                    <span className="dim n">
                          &nbsp;(
                      <FormattedMessage id="general.alternate" />):
                    </span>
                  </label>
                  <span className="value">{phoneFormat(contact.mobilePhone)}</span>
                </div> :
                 null}
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(CustomerContactTrashBinRecord);
